module.exports = __webpack_public_path__ + "static/kirifont-webfont-7597ad62df40db3b0ffdfa0b68e6fd25.woff2";